import { useMemo } from "react";

import { getCappedState } from "./cappedConversationStorage";

interface UseEffectiveCappedMessageIdArgs {
  conversationId: string | null;
  /** undefined = not loaded yet (use localStorage fallback), null = confirmed not capped, string = capped */
  cappedMessageId: string | null | undefined;
}

/**
 * Returns the effective capped message ID for a conversation.
 * - If cappedMessageId is a string: use it (API confirmed capped)
 * - If cappedMessageId is null: return null (API confirmed NOT capped)
 * - If cappedMessageId is undefined: fall back to localStorage (API hasn't responded yet)
 */
export const useEffectiveCappedMessageId = ({ conversationId, cappedMessageId }: UseEffectiveCappedMessageIdArgs): string | null => {
  return useMemo(() => {
    // API confirmed capped
    if (cappedMessageId) return cappedMessageId;
    // API confirmed NOT capped
    if (cappedMessageId === null) return null;
    // API hasn't responded yet (undefined) - fall back to localStorage
    if (!conversationId) return null;

    const storedState = getCappedState({ conversationId });
    return storedState?.lastCappedMessageId ?? null;
  }, [conversationId, cappedMessageId]);
};
